import useIsDesktop from 'hooks/useIsDesktop';
import { isWeb } from 'utils/deviceUtils';

const useShadow = () => {
  const isDesktop = useIsDesktop();
  const defaultShadowDistance = isWeb && isDesktop ? 0 : 10;

  return {
    defaultShadowDistance,
  };
};

export default useShadow;
